import { render, staticRenderFns } from "./NFTsTable.vue?vue&type=template&id=425187e2&scoped=true&"
import script from "./NFTsTable.vue?vue&type=script&lang=ts&"
export * from "./NFTsTable.vue?vue&type=script&lang=ts&"
import style0 from "./NFTsTable.vue?vue&type=style&index=0&id=425187e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425187e2",
  null
  
)

export default component.exports